import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const GridTwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  .single-time-inp {
    width: 100% !important;
  }
`;

export const GridEqualColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const RequiredIndicator = styled.span`
  color: #ff4d4f;
`;

export const FeaturesInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s ease;
  &:focus {
    border-color: #4096ff;
  }

  &::placeholder {
    color: #bfbfbf;
  }
`;

export const FeaturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  min-height: 32px;
`;

export const FeatureTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background-color: #f0f5ff;
  border: 1px solid #d6e4ff;
  border-radius: 6px;
  font-size: 13px;
  color: #1677ff;
`;

export const RemoveFeatureButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;

  &:hover {
    opacity: 0.7;
  }
`;

export const FeaturesSection = styled.div`
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 6px;
  margin-top: 8px;
`;

export const FeatureItem = styled.div`
  margin-bottom: 12px;
`;

export const FeatureRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const CharacterCounter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
`;

export const CounterText = styled.span`
  font-size: 12px;
  margin-top: -20px;
`;

export const AddFeatureButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 8px;
  width: 100%;
`;

export const CounterTextReq = styled.span`
  font-size: 12px;
  margin-top: -10px;
`;
export const ErrorText = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  margin-top: -20px;
`;

export const ErrorText3 = styled.div`
  color: #e63946;
  font-weight: 600;
  padding: 3px 0 2px 0;
  display: flex;
  gap: 3px;
  justify-content: start;
  font-size: 12px;
  line-height: 12px;
  position: absolute;
`;
